<template>
  <Transition name="fade">
    <div class="loader-overlay" v-if="start">
      <div class="loader-card">
        <div class="spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
        </div>
        <div class="loader-text">
          <p class="loader-title">درحال دریافت اطلاعات از سرور</p>
          <p class="loader-subtitle">لطفاً شکیبا باشید</p>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: ['start'],
};
</script>

<style scoped>
.loader-overlay {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(20, 20, 25, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.loader-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 32px 40px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow:
    0 10px 40px rgba(0, 0, 0, 0.25),
    0 2px 8px rgba(0, 0, 0, 0.08);
  min-width: 220px;
}

.spinner {
  position: relative;
  width: 56px;
  height: 56px;
}

.spinner-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #6366f1;
  animation: spin 1.2s cubic-bezier(0.5, 0.1, 0.5, 0.9) infinite;
}

.spinner-ring:nth-child(2) {
  inset: 7px;
  border-top-color: #a5b4fc;
  animation-duration: 1.6s;
  animation-direction: reverse;
}

.spinner-ring:nth-child(3) {
  inset: 14px;
  border-top-color: #c7d2fe;
  animation-duration: 2s;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loader-text {
  text-align: center;
}

.loader-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.6;
}

.loader-subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 400;
  color: #6b7280;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media only screen and (max-width: 600px) {
  .loader-card {
    padding: 24px 28px;
    min-width: 180px;
  }
}
</style>
